export default "__VITE_ASSET__C6g4hEp6__"